<template>
    <div v-if="mission">
        <div v-if="showHeader" class="d-flex align-items-center gap-2 mb-2">
            <h6 class="mb-0">Chauffeurs</h6>
            <small class="text-muted" v-if="countText">· {{ countText }}</small>
        </div>

        <template v-if="hasMembers">
            <ul class="list-group list-group-flush">
                <li v-for="m in mission.members" :key="m.id" class="list-group-item px-0">
                    <div class="d-flex align-items-center">
                        <div class="avatar me-3" :aria-label="initials(m)">
                            {{ initials(m) }}
                        </div>
                        <div class="flex-fill min-w-0">
                            <div class="fw-semibold text-truncate" :title="fullName(m)">
                                {{ fullName(m) }}
                            </div>
                            <div class="text-muted small text-truncate">
                                Chauffeur
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </template>
        <template v-else>
            <div class="text-muted">Aucun chauffeur affecté.</div>
        </template>
    </div>
    <div v-else />
</template>

<script>
export default {
    name: 'MembersListCompact',
    props: {
        mission: { type: Object, required: true },
        showHeader: { type: Boolean, default: true },
    },
    computed: {
        hasMembers() {
            return Array.isArray(this.mission?.members) && this.mission.members.length > 0;
        },
        countText() {
            if (!this.hasMembers) return '';
            const n = this.mission.members.length;
            return n > 1 ? `${n} chauffeurs` : `1 chauffeur`;
        },
    },
    methods: {
        fullName(m) {
            return `${m?.firstName || ''} ${m?.lastName || ''}`.trim();
        },
        initials(m) {
            const f = (m?.firstName || '').trim();
            const l = (m?.lastName || '').trim();
            return `${f.charAt(0)}${l.charAt(0)}`.toUpperCase() || '??';
        }
    }
}
</script>

<style scoped>
.avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: .9rem;
    background: var(--bs-primary-bg-subtle, rgba(13, 110, 253, .08));
    color: var(--bs-primary, #0d6efd);
    border: 1px solid rgba(13, 110, 253, .15);
    user-select: none;
    text-transform: uppercase;
}

.min-w-0 {
    min-width: 0;
}

/* pour text-truncate sur la ligne */
</style>